import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { loginSchema } from "../../utils/schema";
import { loginCall,verifySubdomain } from "../slice";
import { toast } from "react-toastify";
import Loader from "../../component/Loader";
import { subdomainSelector } from "../subdomainSlice";

function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [toggle, setToggle] = useState(false);
  const [loading, setLoading] = useState(false);
  const subdomain = useSelector(subdomainSelector);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const message = queryParams.get("message");

    if (message) {
      toast.error(decodeURIComponent(message), { autoClose: 8000 });
    }
  }, []);

  const {
    register,
    formState: { errors },
    handleSubmit,
    formState,
  } = useForm({
    mode: "onTouched",
    reValidateMode: "onSubmit",
    resolver: yupResolver(loginSchema),
    shouldFocusError: true,
  });

  const { isSubmitted } = formState;

  const onSubmit = (data) => {
    setLoading(true);
    dispatch(
      loginCall({
        email: data?.email?.trim()?.toLowerCase(),
        password: data?.password,
        user_type: "user",
        url_id: subdomain
      })
    ).then(async (res) => {
      setLoading(false);

      if (res?.payload?.code === 1) {
        await localStorage.setItem("token_u", res?.payload?.data?.token);
        localStorage.removeItem('isModalShow');
        await localStorage.setItem(
          "user",
          JSON.stringify(res?.payload?.data?.user)
        );
        navigate("/dashboard", { replace: true });
        //toast.success(res?.payload?.message);
      } else {
        if (res?.payload?.data?.user) {
          await localStorage.setItem("token_u", res?.payload?.data?.token);
          await localStorage.setItem(
            "user",
            JSON.stringify(res?.payload?.data?.user)
          );
        }
        const user = res?.payload?.data?.user;
        toast.error(res?.payload?.message, {  autoClose: false,  closeButton: true});

        if (user?.profile_stag === "0") {
          // create account complete go to otp page
          navigate("/create-account", { replace: true });
        } else if (user?.profile_stag === "1") {
          // otp is complete go to address page
          navigate("/address", { replace: true });
        } else if (user?.profile_stag === "2") {
          // address is complete go to add student detail page
          navigate(`/add-student-details`, {
            replace: true,
          });
        } else if (user?.profile_stag === "3") {
          // add student detail is complete go to membership modal
          navigate(`/add-student-details`, {
            replace: true,
          });
        }
      }
    });
  };

  return (
    <section className="">
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12 col-md-5 col-lg-5 d-flex justify-content-center order-2 order-md-1"
            style={{
              backgroundColor: 'white',
              minHeight: '100vh'
            }}
          >
            <div style={{ 
              width: '100%', 
              maxWidth: 500, 
              textAlign: 'center',
              padding: '0px 20px'
            }}>
              {/* Logo and Title Section */}
              <div style={{ 
                textAlign: 'left', 
                marginTop: 20, 
                marginBottom: 15, 
                display: 'flex',
                alignItems: 'flex-start',
                gap: '20px'
              }}>
                <img
                  src={localStorage.getItem('company_logo') || '/assets/img/banner_logo.png'}
                  alt="logo"
                  style={{
                    width: 100,
                    height: 100,
                    objectFit: 'cover',
                    borderRadius: '50%',
                  }}
                />
                <div>
                  <h2 style={{ 
                    fontWeight: 700, 
                    fontSize: '20px', 
                    color: '#23235b', 
                    margin: '25px 0 8px 0',
                    lineHeight: '1.0'
                  }}>
                    Log in to Your Club Account
                  </h2>
                  <p style={{ 
                    fontSize: '16px', 
                    color: '#666', 
                    margin: 0,
                    fontWeight: 400
                  }}>
                    Powered by BookInClass
                  </p>
                </div>
              </div>

              {/* Help Section */}
              <div style={{
                backgroundColor: '#b3e6f9',
                color: 'white',
                padding: '12px 20px',
                marginBottom: '20px',
                fontWeight: 700,
                fontSize: '18px',
                textAlign: 'left', 
                color: '#23235b'
              }}>
                Help
              </div>

              {/* Instructions */}
              <div style={{ 
                textAlign: 'left',
                fontSize: '15px', 
                color: '#333', 
                lineHeight: 1.6,
                marginBottom: '15px'
              }}>
                <div style={{ fontWeight: 600, fontSize: '18px', marginBottom: '16px' }}>
                  How to Get Started
                </div>
                <p style={{ marginBottom: '16px' }}>
                  <strong>New to BookInClass?</strong><br/> Click Create Account (bottom right), enter your details, verify your email using the OTP, then add your child or student to your profile.
                </p>
                <p style={{ marginBottom: '16px' }}>
                  <strong>Already have an account?</strong><br/> Enter your email and password, click Log In, then select and book your class, membership, or event.
                </p>
                <p style={{ marginBottom: '0' }}>
                  <strong>Having trouble logging in?</strong><br/> Click Forgot your password? to reset it.
                </p>
              </div>

              {/* Teacher Login Button */}
              <button
                style={{
                  width: '70%',
                  color: '#fff',
                  border: 'none',
                  borderRadius: 6,
                  padding: '12px 0',
                  fontWeight: 700,
                  fontSize: 16,
                  cursor: 'pointer',
                  transition: 'background-color 0.2s ease',
                  display:'none'
                }}
                className="btn btn-submit btn-animated"
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#2a9fd8';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#3bb6ff';
                }}
                onClick={() => {
                  window.open("http://teacher.bookinclass.co.uk", "_self");
                }}
              >
                Teacher Login
              </button>
            </div>
          </div>
          <div className="col-sm-12 col-md-7 col-lg-7 order-1 order-md-2" style={{backgroundColor: '#b3e6f9'}}>
            {/* <div className="form-group col-sm-12 col-md-12 text-end">
              <span
                className="btn-teacher fw-bold fs-5 cursor-pointer"
                onClick={() => {
                  window.open("http://teacher.bookinclass.co.uk", "_self");
                }}
              >
                Teacher Access
              </span>
            </div> */}
            <div className="form-style mt-5">
              <form className="row" onSubmit={handleSubmit(onSubmit)}>
                <div className="form-group col-sm-12 col-md-12 text-center mb-4">
                  <h2 className="mdl-ttl">log in</h2>
                  <p>To access your account, enter your email and password in the fields provided.
                  </p>
                </div>
                <div className="form-group col-sm-12 col-md-12 col-lg-12 mb-4">
                  <label className="fw-bold">Email ID / Username</label>
                  <div className="input-container">
                    <input
                      type="text"
                      className="form-control ps-4"
                      placeholder="Email Address or Username"
                      name="email"
                      {...register("email")}
                    />
                    <img
                      src="assets/img/email.png"
                      className="input-img"
                      alt=""
                    />
                  </div>
                  {errors?.email && (
                    <div className="text-red">{errors?.email?.message}</div>
                  )}
                </div>
                <div className="form-group col-sm-12 col-md-12 col-lg-12 mb-4">
                  <label className="fw-bold">Password</label>

                  <div className="input-container">
                    <input
                      id="password-field"
                      type={toggle ? "text" : "password"}
                      className="form-control ps-4"
                      placeholder="Password"
                      name="password"
                      {...register("password")}
                    />
                    <img
                      src="assets/img/password.png"
                      className="input-img pass"
                      alt=""
                    />
                    <span
                      onClick={() => {
                        setToggle(!toggle);
                      }}
                      className="pass-view field-icon toggle-password cursor-pointer"
                    ></span>
                  </div>
                  {errors?.password && (
                    <div className="text-red">{errors?.password?.message}</div>
                  )}
                </div>
                <div className="form-group col-sm-12 col-md-12 text-center">
                  <button
                    type="submit"
                    className="btn btn-submit btn-animated"
                    disabled={loading}
                    style={{ width: "100%" }}
                  >
                    {loading ? <Loader /> : "Log In"}
                  </button>
                </div>
                <div className="form-group col-sm-12 col-md-12 col-lg-12 mb-2 text-center">
                  <div className="input-container">
                    <p>
                      <Link
                        to="/forget-password"
                        className="theme-color fw-bold"
                      >
                        Forgot Password?
                      </Link>
                    <p style={{ fontSize: '0.8em' }}>If you've forgotten your password, click "Forgot your password" to reset it.</p>
                    </p>
                  </div>
                </div>
                

                <div className="form-group col-sm-12 col-md-12 col-lg-12 mb-4 text-center">
                  <div className="input-container">
                    <p>
                      Don't have an account?{" "}
                      <Link
                        to="/create-account"
                        className="theme-color fw-bold"
                      >
                        Create Account
                      </Link>
                    </p>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Login;
